package com.evoapps.evoshift.ui.workplaces

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.EventNote
import androidx.compose.material.icons.filled.Remove
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilledTonalIconButton
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.stateDescription
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.ContractType
import com.evoapps.evoshift.domain.model.RequestLimit
import com.evoapps.evoshift.domain.model.RequestSettings
import com.evoapps.evoshift.domain.model.RequestSettingsState
import com.evoapps.evoshift.domain.model.RequestTypeRule
import com.evoapps.evoshift.domain.model.SystemContractType
import com.evoapps.evoshift.domain.requests.RequestCatalog
import com.evoapps.evoshift.domain.requests.RequestSettingsGroup
import com.evoapps.evoshift.domain.requests.RequestType
import com.evoapps.evoshift.domain.requests.RequestTypeInfo
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.user.contractLabel
import com.evoapps.evoshift.ui.user.payRes
import com.evoapps.evoshift.ui.util.label
import com.evoapps.evoshift.viewmodels.RequestTypeDraft
import com.evoapps.evoshift.viewmodels.SettingsEvent
import com.evoapps.evoshift.viewmodels.enabledTypeNames
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogSectionLabel
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.ErrorOnNavy
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoSwitchRow
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.contract_short_b2b
import evoshift.composeapp.generated.resources.contract_short_civil
import evoshift.composeapp.generated.resources.contract_short_employment
import evoshift.composeapp.generated.resources.contract_short_owner
import evoshift.composeapp.generated.resources.contract_short_specific_task
import evoshift.composeapp.generated.resources.request_group_work
import evoshift.composeapp.generated.resources.request_limit_blood
import evoshift.composeapp.generated.resources.request_limit_days_year
import evoshift.composeapp.generated.resources.request_limit_hours_year
import evoshift.composeapp.generated.resources.request_limit_less
import evoshift.composeapp.generated.resources.request_limit_more
import evoshift.composeapp.generated.resources.request_type_available_for
import evoshift.composeapp.generated.resources.request_type_contracts_none
import evoshift.composeapp.generated.resources.request_type_enabled
import evoshift.composeapp.generated.resources.request_type_limits
import evoshift.composeapp.generated.resources.request_type_own_contracts
import evoshift.composeapp.generated.resources.request_type_pay
import evoshift.composeapp.generated.resources.request_types_all_contracts
import evoshift.composeapp.generated.resources.request_types_group_labour_code
import evoshift.composeapp.generated.resources.request_types_group_occasions
import evoshift.composeapp.generated.resources.request_types_group_sickness
import evoshift.composeapp.generated.resources.request_types_group_unpaid
import evoshift.composeapp.generated.resources.request_types_more
import evoshift.composeapp.generated.resources.request_types_no_contract
import evoshift.composeapp.generated.resources.request_types_none_on
import evoshift.composeapp.generated.resources.request_types_state_custom
import evoshift.composeapp.generated.resources.request_types_state_legacy
import evoshift.composeapp.generated.resources.request_types_state_recommended
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.settings_limit_explain_blood
import evoshift.composeapp.generated.resources.settings_limit_explain_carer
import evoshift.composeapp.generated.resources.settings_limit_explain_childcare
import evoshift.composeapp.generated.resources.settings_limit_explain_force_majeure
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/** Test tags of the request types' settings. */
object RequestTypeRuleTags {
    const val CARD_LIST = "request_types_card_list"
    const val CARD_MORE = "request_types_card_more"
    const val CARD_NONE = "request_types_card_none"
    const val DIALOG = "request_types_dialog"
    const val STATE = "request_types_state"
    const val RESTORE = "request_types_restore"
    const val DETAIL = "request_type_detail"
    const val DETAIL_ENABLED = "request_type_detail_enabled"
    const val DETAIL_ALL = "request_type_detail_all"
    const val DETAIL_MISSING = "request_type_detail_missing"
    const val DETAIL_SAVE = "request_type_detail_save"
    fun cardItem(name: String) = "request_types_card_$name"
    fun check(name: String) = "request_type_check_$name"
    fun row(name: String) = "request_type_row_$name"
    fun summary(name: String) = "request_type_summary_$name"
    fun missing(name: String) = "request_type_missing_$name"
    fun contract(key: String) = "request_type_contract_$key"
    fun limit(limit: RequestLimit) = "request_type_limit_${limit.name}"
    fun limitLess(limit: RequestLimit) = "request_type_limit_less_${limit.name}"
    fun limitMore(limit: RequestLimit) = "request_type_limit_more_${limit.name}"
}

/** A contract the request types can be offered on: a built-in one (its enum name) or one of the owner's. */
data class ContractColumn(val key: String, val short: String, val full: String, val custom: Boolean, val note: String? = null)

/** The short name of a built-in contract (the dialog's contract lines). */
@Composable
fun contractShortLabel(type: SystemContractType): String = stringResource(
    when (type) {
        SystemContractType.STANDARD_EMPLOYMENT, SystemContractType.NOT_SET -> Res.string.contract_short_employment
        SystemContractType.CIVIL_LAW_CONTRACT -> Res.string.contract_short_civil
        SystemContractType.SPECIFIC_TASK_CONTRACT -> Res.string.contract_short_specific_task
        SystemContractType.B2B_CONTRACTOR -> Res.string.contract_short_b2b
        SystemContractType.OWNER_PARTNER -> Res.string.contract_short_owner
    }
)

/** The built-in contracts, then the owner's own contract types. */
@Composable
fun contractColumns(custom: List<ContractType>): List<ContractColumn> =
    RequestTypeRule.CONTRACTS.map { ContractColumn(it.name, contractShortLabel(it), contractLabel(it), custom = false) } +
        custom.map { type ->
            val name = type.label.ifBlank { type.id }
            ContractColumn(type.id, name, name, custom = true, note = type.systemType.takeIf { it != SystemContractType.NOT_SET }?.let { contractShortLabel(it) })
        }

fun RequestSettingsGroup.labelRes(): StringResource = when (this) {
    RequestSettingsGroup.LABOUR_CODE_LEAVE -> Res.string.request_types_group_labour_code
    RequestSettingsGroup.OCCASIONS_AND_CARE -> Res.string.request_types_group_occasions
    RequestSettingsGroup.SICKNESS_AND_ZUS -> Res.string.request_types_group_sickness
    RequestSettingsGroup.UNPAID -> Res.string.request_types_group_unpaid
    RequestSettingsGroup.WORK -> Res.string.request_group_work
}

@Composable
internal fun RequestTypeInfo.label(): String = when (val t = type) {
    is RequestType.Leave -> t.type.label()
    is RequestType.Work -> t.kind.label()
}

/** "Umowa o pracę, Zlecenie", "Wszystkie umowy" or "Nie wybrano żadnej umowy". */
@Composable
internal fun contractsSummary(rule: RequestTypeRule, columns: List<ContractColumn>): String = when {
    rule.forAllContracts -> stringResource(Res.string.request_types_all_contracts)
    !rule.hasAnyContract -> stringResource(Res.string.request_types_no_contract)
    else -> columns.filter { rule.offersContract(it.key) }.joinToString(", ") { it.short }
}

@Composable
internal fun RequestSettingsState.label(): String = stringResource(
    when (this) {
        RequestSettingsState.LEGACY_DEFAULTS -> Res.string.request_types_state_legacy
        RequestSettingsState.RECOMMENDED -> Res.string.request_types_state_recommended
        RequestSettingsState.CUSTOM -> Res.string.request_types_state_custom
    }
)

/** SH-263: how many switched-on types the card names before "and N more". */
const val REQUEST_TYPES_ON_CARD = 5

/**
 * SH-263: the settings' "Request types" card: the types switched on (at most
 * [REQUEST_TYPES_ON_CARD], then "and N more"), or a line that none is. Its Edit opens
 * [RequestTypesDialog].
 */
@Composable
fun RequestTypesCardContent(requests: RequestSettings) {
    val on = requests.enabledTypeNames()
    if (on.isEmpty()) {
        Text(
            stringResource(Res.string.request_types_none_on),
            style = MaterialTheme.typography.bodySmall,
            color = DeepNavy.copy(alpha = 0.75f),
            modifier = Modifier.testTag(RequestTypeRuleTags.CARD_NONE)
        )
        return
    }
    Column(Modifier.fillMaxWidth().testTag(RequestTypeRuleTags.CARD_LIST), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        on.take(REQUEST_TYPES_ON_CARD).forEach { name ->
            Text(
                RequestCatalog.all.first { it.type.name == name }.label(),
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.SemiBold,
                color = DeepNavy,
                modifier = Modifier.testTag(RequestTypeRuleTags.cardItem(name))
            )
        }
        if (on.size > REQUEST_TYPES_ON_CARD) {
            Text(
                stringResource(Res.string.request_types_more, on.size - REQUEST_TYPES_ON_CARD),
                style = MaterialTheme.typography.bodyMedium,
                color = DeepNavy.copy(alpha = 0.75f),
                modifier = Modifier.testTag(RequestTypeRuleTags.CARD_MORE)
            )
        }
    }
}

/** A type's settings: a sheet on phones, a dialog on wide screens. */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun RequestTypeDetail(draft: RequestTypeDraft, columns: List<ContractColumn>, wide: Boolean, canEdit: Boolean, onEvent: (SettingsEvent) -> Unit) {
    val info = RequestCatalog.all.first { it.type.name == draft.typeName }
    val title = info.label()
    val close = { onEvent(SettingsEvent.CloseRequestType) }
    val save = DialogAction(stringResource(Res.string.save), { onEvent(SettingsEvent.SaveRequestType) }, enabled = !draft.missingContract)
    if (wide) {
        EvoDialog(
            title = title,
            icon = Icons.Default.EventNote,
            onDismiss = close,
            width = DialogWidth.Regular,
            confirm = if (canEdit) save else null
        ) {
            Column(Modifier.testTag(RequestTypeRuleTags.DETAIL), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                DetailBody(draft, info, columns, canEdit, onEvent)
            }
        }
    } else {
        EvoBottomSheet(onDismiss = close, title = title, icon = Icons.Default.EventNote) {
            Column(Modifier.testTag(RequestTypeRuleTags.DETAIL), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                DetailBody(draft, info, columns, canEdit, onEvent)
                if (canEdit) EvoPrimaryButton(save, Modifier.fillMaxWidth().testTag(RequestTypeRuleTags.DETAIL_SAVE))
            }
        }
    }
}

/** The switch, the contracts, the law's numbers and who pays (on the dialog's navy). */
@Composable
private fun DetailBody(draft: RequestTypeDraft, info: RequestTypeInfo, columns: List<ContractColumn>, canEdit: Boolean, onEvent: (SettingsEvent) -> Unit) {
    val rule = draft.rule
    EvoSwitchRow(
        checked = rule.enabled,
        onCheckedChange = { onEvent(SettingsEvent.DraftRequestTypeEnabled(it)) },
        label = stringResource(Res.string.request_type_enabled),
        enabled = canEdit,
        modifier = Modifier.testTag(RequestTypeRuleTags.DETAIL_ENABLED)
    )
    DialogSection(stringResource(Res.string.request_type_available_for)) {
        Column {
            EvoCheckboxRow(
                checked = rule.forAllContracts,
                onCheckedChange = { onEvent(SettingsEvent.DraftAllContracts(it)) },
                label = stringResource(Res.string.request_types_all_contracts),
                enabled = canEdit,
                modifier = Modifier.testTag(RequestTypeRuleTags.DETAIL_ALL)
            )
            columns.filter { !it.custom }.forEach { ContractCheckbox(it, rule, canEdit, onEvent) }
            if (columns.any { it.custom }) {
                DialogSectionLabel(stringResource(Res.string.request_type_own_contracts), Modifier.padding(top = 8.dp))
                columns.filter { it.custom }.forEach { ContractCheckbox(it, rule, canEdit, onEvent) }
            }
        }
        if (draft.missingContract) {
            Text(
                stringResource(Res.string.request_type_contracts_none),
                color = ErrorOnNavy,
                style = MaterialTheme.typography.bodyMedium,
                modifier = Modifier.testTag(RequestTypeRuleTags.DETAIL_MISSING)
            )
        }
    }
    val limits = RequestLimit.of(draft.typeName)
    if (limits.isNotEmpty()) {
        DialogSection(stringResource(Res.string.request_type_limits)) {
            limits.forEach { limit ->
                LimitStepper(limit, draft.numbers[limit], canEdit) { onEvent(SettingsEvent.DraftLimit(limit, it)) }
            }
            Text(limitHint(draft.typeName), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.75f))
        }
    }
    DialogSection(stringResource(Res.string.request_type_pay)) {
        Text(stringResource(info.payRes()), style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.85f))
    }
}

@Composable
private fun ContractCheckbox(column: ContractColumn, rule: RequestTypeRule, canEdit: Boolean, onEvent: (SettingsEvent) -> Unit) {
    EvoCheckboxRow(
        checked = rule.offersContract(column.key),
        onCheckedChange = { onEvent(SettingsEvent.DraftContract(column.key, it)) },
        label = column.full,
        supporting = column.note,
        enabled = canEdit,
        modifier = Modifier.testTag(RequestTypeRuleTags.contract(column.key))
    )
}

/** SH-231: what the type's numbers do in the app, and the law's values they start from. */
@Composable
private fun limitHint(typeName: String): String = when (typeName) {
    "BLOOD_DONATION" -> stringResource(Res.string.settings_limit_explain_blood, RequestLimit.BLOOD_DONATION_DAYS.statutory)
    "CHILDCARE" -> stringResource(Res.string.settings_limit_explain_childcare, RequestLimit.CHILDCARE_DAYS.statutory, RequestLimit.CHILDCARE_HOURS.statutory)
    "FORCE_MAJEURE" -> stringResource(Res.string.settings_limit_explain_force_majeure, RequestLimit.FORCE_MAJEURE_DAYS.statutory, RequestLimit.FORCE_MAJEURE_HOURS.statutory)
    else -> stringResource(Res.string.settings_limit_explain_carer, RequestLimit.CARER_LEAVE_DAYS.statutory)
}

/** − value + for one of the law's numbers, within its bounds. */
@Composable
private fun LimitStepper(limit: RequestLimit, value: Int, canEdit: Boolean, onChange: (Int) -> Unit) {
    val label = stringResource(
        when {
            limit == RequestLimit.BLOOD_DONATION_DAYS -> Res.string.request_limit_blood
            limit.hours -> Res.string.request_limit_hours_year
            else -> Res.string.request_limit_days_year
        }
    )
    val buttons = IconButtonDefaults.filledTonalIconButtonColors(
        containerColor = Color.White.copy(alpha = 0.10f),
        contentColor = LightGold,
        disabledContainerColor = Color.White.copy(alpha = 0.04f),
        disabledContentColor = Color.White.copy(alpha = 0.3f)
    )
    Row(Modifier.fillMaxWidth().heightIn(min = 48.dp), verticalAlignment = Alignment.CenterVertically) {
        Text(label, color = Color.White, style = MaterialTheme.typography.bodyLarge, modifier = Modifier.weight(1f))
        FilledTonalIconButton(
            onClick = { onChange(value - 1) },
            enabled = canEdit && value > limit.min,
            colors = buttons,
            modifier = Modifier.size(40.dp).handCursor().testTag(RequestTypeRuleTags.limitLess(limit))
        ) { Icon(Icons.Default.Remove, stringResource(Res.string.request_limit_less, label)) }
        Text(
            "$value",
            color = Color.White,
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center,
            modifier = Modifier.widthIn(min = 44.dp).testTag(RequestTypeRuleTags.limit(limit)).semantics { stateDescription = "$value" }
        )
        FilledTonalIconButton(
            onClick = { onChange(value + 1) },
            enabled = canEdit && value < limit.max,
            colors = buttons,
            modifier = Modifier.size(40.dp).handCursor().testTag(RequestTypeRuleTags.limitMore(limit))
        ) { Icon(Icons.Default.Add, stringResource(Res.string.request_limit_more, label)) }
    }
}
